import { createSlice } from "@reduxjs/toolkit";
import {
  getMyReviews,
  createReview,
  updateReview,
  deleteReview,
  getAllReviewsAdmin,
  toggleReviewStatus,
} from "./thunk";

const initialState = {
  reviews: [],
  loading: false,
  error: null,
};

const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ========================
      // GET MY REVIEWS
      // ========================
      .addCase(getMyReviews.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload;
      })
      .addCase(getMyReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // CREATE REVIEW
      // ========================
      .addCase(createReview.pending, (state) => {
        state.loading = true;
      })
      .addCase(createReview.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews.unshift(action.payload);
      })
      .addCase(createReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // UPDATE REVIEW
      // ========================
      .addCase(updateReview.fulfilled, (state, action) => {
        const index = state.reviews.findIndex(
          (r) => r.id === action.payload.id,
        );
        if (index !== -1) {
          state.reviews[index] = action.payload;
        }
      })

      // ========================
      // DELETE REVIEW
      // ========================
      .addCase(deleteReview.fulfilled, (state, action) => {
        state.reviews = state.reviews.filter((r) => r.id !== action.payload);
      })

      // ========================
      // ADMIN – GET ALL REVIEWS
      // ========================
      .addCase(getAllReviewsAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllReviewsAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload;
      })
      .addCase(getAllReviewsAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // ADMIN – TOGGLE REVIEW STATUS
      // ========================
      .addCase(toggleReviewStatus.fulfilled, (state, action) => {
        const index = state.reviews.findIndex(
          (r) => r.id === action.payload.id,
        );
        if (index !== -1) {
          state.reviews[index] = action.payload;
        }
      });
  },
});

export default reviewSlice.reducer;
